{
  "fr": {
    "dataProtection": {
      "copyright": "Respecte les droits d'auteur lorsque tu utilises des contenus tiers",
      "data": "Ne partage jamais d'informations sensibles ou personnelles avec une application IA",
      "deletionPolicy": {
        "content": "En raison des exigences de protection des données, tous les contenus des élèves sont supprimés après 365 jours."
      },
      "pupils": "N'utilise pas de contenus contenant des données personnelles te concernant ou concernant d'autres personnes",
      "students": "N'utilise pas de contenus contenant des données personnelles de tes élèves",
      "worksheets": "Ne t'inquiète pas : tes fiches d'exercices restent intactes."
    }
  }
}
